import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function evaluationEmployeeList(
  accountId: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${accountId}/evaluation/employee/list${queryString}`,
  );
}

export async function evaluationEmployeeShow(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.get(
    `account/${account_id}/evaluation/employee/${item_id}/show`,
  );
}

export async function evaluationEmployeeCreate(
  account_id: string,
  payload: {
    evaluation_id: string;
    employee_id: string;
  },
) {
  return await clientAxios.post(
    `account/${account_id}/evaluation/employee/create`,
    payload,
  );
}

export async function evaluationEmployeeDelete(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/evaluation/employee/${item_id}/delete`,
  );
}
